import React, { useMemo } from 'react';
import { Field } from 'redux-form'

import { SelectInput } from 'components'

export const PlaceFieldBase = ({ bookedPlaces, places }) => (
  <Field
    fullWidth
    name='place'
    label='Місце'
    margin='normal'
    component={SelectInput}
  >
    <option value='' />

    {places.map((place) => (
      <option
        key={place}
        value={place}
        disabled={bookedPlaces.includes(`${place}`)}
      >
        {place}
      </option>
    ))}
  </Field>
)



// WEBPACK FOOTER //
// ./src/components/PlaceField/PlaceField.js